<template>
    <div>
        <PopoverRight ref="stationPopover" width="500px" >
            <div class="popover-slider-bar">
                    <h1 class="bar-title">新增地铁站点</h1>
                    <el-form class="form-container" :model="stationInfo" :rules="stationRules" ref="stationForm">
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">站点名称</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item prop="name">
                                    <el-input placeholder="请输入站点名称" class="input-control" v-model="stationInfo.name"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">站点标注</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item label="" prop="map_lng_lat">
                                    <el-input placeholder="请选择站点标注" class="input-control" v-model="stationInfo.map_lng_lat" disabled="disabled" >
                                        <span slot="append" @click="openMap">获取</span>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-button">
                            <el-button type="primary" @click="submitForm">保 存</el-button>
                            <el-button type="info" plain @click.stop.prevent="hideMenu">取 消</el-button>
                        </div>
                    </el-form>
                </div>
        </PopoverRight>
        <Map :callback="callback" ref="mapLocationRef" />
    </div>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import Map from '@/components/map/index'
import { createSubwayStations, editSubwayStations } from '@/service/site'
import { validateChat } from '@/utils/validate'
export default {
    name: 'AddStation',
    props: {
        stationCallback: Function
    },
    components: {
        PopoverRight,
        Map
    },
    data () {
        return {
            stationInfo: {
                name: '',
                map_lng_lat: '',
                map_lng: '',
                map_lat: ''
            },
            stationRules: {
                name: [
                    { required: true, message: '请输入站点名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '站点名称长度为2-10个字符之间', trigger: 'blur' },
                    {validator: validateChat, type:4, trigger: 'blur', result:'站点名称' }
                ],
                map_lng_lat: [
                    { required: true, message: '请选择站点标注', trigger: 'blur' }
                ]
            },
            isEdit: false
        }
    },
    methods: {
        openMenu (subwayId, cityName, data) {
            this.cityName = cityName
            this.subwayId  = subwayId
            if (data) {
                this.stationInfo = Object.assign({}, this.stationInfo, data)
                this.stationInfo.map_lng_lat = `${this.stationInfo.map_lng}   ${this.stationInfo.map_lat}`
                this.isEdit = true
            }
            this.$refs.stationPopover && this.$refs.stationPopover.open()
        },
        hideMenu () {
            this.$refs.stationPopover && this.$refs.stationPopover.hide()
            this.$refs.stationForm && this.$refs.stationForm.clearValidate()
            this.reset()
        },
        submitForm () {
            this.$refs.stationForm && this.$refs.stationForm.validate(status => {
                if (!status) return null
                this.isEdit ? this.edit() : this.create()
            })
        },
        create () {
            createSubwayStations(this.subwayId , this.stationInfo).then(data => {
                this.stationCallback && this.stationCallback(data)
                this.hideMenu()
                this.$message({
                    type: 'success',
                    message: '添加地铁站点成功'
                })
            }).catch(e => {
                this.$message({
                    type: 'error',
                    message: e.message || '新增地铁站点失败'
                })
            })
        },
        edit () {
            editSubwayStations(this.subwayId ,this.stationInfo.id, this.stationInfo).then(data => {
                this.stationCallback && this.stationCallback(data, true)
                this.hideMenu()
                this.$message({
                    type: 'success',
                    message: '编辑地铁站点成功'
                })
            }).catch(e => {
                this.$message({
                    type: 'error',
                    message: e.message || '编辑地铁站点失败'
                })
            })
        },
        openMap () {
            this.$refs.mapLocationRef && this.$refs.mapLocationRef.openDialog(this.stationInfo.map_lng, this.stationInfo.map_lat, this.cityName)
        },
        callback (lng, lat) {
            this.$set(this.stationInfo, 'map_lng', lng + '')
            this.$set(this.stationInfo, 'map_lat', lat + '')
            this.$set(this.stationInfo, 'map_lng_lat', lng + '   ' + lat)
        },
        reset () {
            this.stationInfo= {
                name: '',
                map_lng_lat: '',
                map_lng: '',
                map_lat: ''
            }
            this.isEdit = false
        }
    }
}
</script>
